import { render, staticRenderFns } from "./BackgroundSymbols.vue?vue&type=template&id=62546b4c"
import script from "./BackgroundSymbols.vue?vue&type=script&lang=js"
export * from "./BackgroundSymbols.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSymbols.vue?vue&type=style&index=0&id=62546b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports